export default {
	sec_01: {
		title: {
			one: 'JP WORLD PAY',
			two: 'を使うことで',
			three: '様々な特典が得られます。',
		},
		desc: {
			one: '取引、キャッシュバックの提案やプロモーションコードを積み重ねて、',
			two: 'お金を節約し、お気に入りのお店やブランドから',
			three: '報酬を獲得しましょう。',
		},
		btn: {
			one: '会員登録',
			two: 'アプリダウンロード',
		},
	},
	sec_09: {
		title: {
			one: '自分好みの暗号資産での取引',
			two: '',
		},
		one: {
			desc: {
				one: 'JP WORLD PAYはあなたが購入商品や購入場所に基づいて、',
				two: 'あなたが気に入ると思われる取引、製品及びお店をご紹介します。',
				three: '気に入るお店も増やし続け、アップデートすることを約束します。',
			},
		},
	},
	sec_03: {
		one: {
			title: {
				one: 'Maximize your rewards',
				two: 'より多くの報酬を提供します。',
			},
			desc: {
				one: '取引、キャッシュバック提案の及びプロモーションコードを組み合わせると、',
				two: 'より多くの費用を節約できます。',
				three:
					'お支払い時にプロモーションコードを調べて適用するお手伝をします。',
				four: 'JP WORLD PAYカードは報酬を提供しますか?',
				five: 'ご購入についてチェックアウトし、報酬を受け取るときにご利用頂けます。',
			},
			btn: 'ショッピングを始める',
		},
		two: {
			title: {
				one: 'セキュリティのチェックアウト',
			},
			desc: {
				one: 'JP WORLD PAYで安全に決済する際は、数百万個の',
				two: 'グローバル小売業者からの取引及びキャッシュバック提案をご活用頂けます。',
				three: 'あなたの個人情報は暗号化されており、',
				four: '貴下の許諾がなければ販売または共有は一切致しません。',
			},
			btn: 'あなたを守る方法の詳細を知る',
		},
	},
	common: {
		coming_soon: '準備中です。',
	},
};
